<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>课程信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>学年：</p>
                    <a-input class="input" v-model="info.schoolYear" disabled />
                </div>
                <div class="input-box">
                    <p>学期：</p>
                    <a-select class="input" allowClear v-model="info.semester" disabled>
                        <!-- For years before 2025, keep all options -->
                        <template v-if="year < '2025'">
                            <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                            <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                            <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                        </template>
                        <!-- For 2025 and later, only show two semesters -->
                        <template v-else>
                            <a-select-option :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                        </template>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>开设院系：</p>
                    <a-input class="input" v-model="info.orgName" disabled />
                </div>
                <div class="input-box">
                    <p>课程编号：</p>
                    <a-input class="input" v-model="info.courseId" disabled />
                </div>
                <div class="input-box">
                    <p>课程名：</p>
                    <a-input class="input" v-model="info.courseName" disabled />
                </div>
                <div class="input-box">
                    <p>课程类别：</p>
                    <a-input class="input" v-model="info.courseType" disabled />
                </div>
                <div class="input-box">
                    <p>班级编号：</p>
                    <a-input class="input" v-model="info.classId" disabled />
                </div>
                <div class="input-box">
                    <p>班级名称：</p>
                    <a-input class="input" v-model="info.className" disabled />
                </div>
                <div class="input-box">
                    <p>上课人数(实际)：</p>
                    <a-input class="input" v-model="info.actualAttend" disabled />
                </div>
                <div class="input-box">
                    <p>课程学分：</p>
                    <a-input class="input" v-model="info.credit" disabled />
                </div>
                <div class="input-box">
                    <p>课程总学时：</p>
                    <a-input class="input" v-model="info.courseHours" disabled/>
                </div>
                <div class="input-box">
                    <p>校区：</p>
                    <a-input class="input" v-model="info.campus" disabled/>
                </div>
                <div class="input-box">
                    <p>教室：</p>
                    <a-input class="input" v-model="info.classroom" disabled/>
                </div>
                <div class="input-box">
                    <p>是否自定义教室：</p>
                    <a-input class="input" :value="info.isCustomClassroom==true ? '是':'否'" disabled/>
                </div>
                <div class="input-box" v-if="info.isCustomClassroom">
                    <p>自定义教室：</p>
                    <a-input class="input" v-model="info.customClassroom" disabled/>
                </div>
                <div class="input-box">
                    <p>主讲教师工号：</p>
                    <a-input class="input" v-model="info.teacherId" disabled/>
                </div>
                <div class="input-box">
                    <p>主讲教师：</p>
                    <a-input class="input" v-model="info.teacherName" disabled/>
                </div>
                <div class="input-box">
                    <p>上课时间描述：</p>
                    <a-input class="input" v-model="info.classTimeDesc" disabled/>
                </div>
                <div class="input-box">
                    <p>备注：</p>
                    <a-input class="input" v-model="info.remark" disabled/>
                </div>
                <div class="input-box">
                    <p>是否全日制：</p>
                    <a-input class="input" :value="(info.isFullTime == true ? '全日制':'非全日制')" disabled/>
                </div>
                <div class="input-box">
                    <p>是否全英语：</p>
                    <a-input class="input" :value="(info.isAllEnglish == true ? '全英语':'非全英语')" disabled/>
                </div>
                <div class="input-box">
                    <p>是否博士：</p>
                    <a-input class="input" :value="(info.isDoctor == true ? '博士研究生':'硕士研究生')" disabled/>
                </div>
            </div>
        </div>
        <div class="btn-box">
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { info } from '@/baseAPI/master/course'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                info:{},
                year:'',
                permissions:[],
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.year=getSchoolYear()+''
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)

            info(this.$route.query.id).then(res=>{
                this.info=res.data;
            })
            

        },
        methods:{

        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .answer-input{
        width: calc(100% - 10rem);
        border-color:red;
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .action-btn{
        background-color: #1890ff;
        color: #fff;
        line-height: 32px;
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
    }
</style>
